<p-dialog appDialogoPadrao="pi pi-building" descricao="Setor da estrutura organizacional." [header]="titulo" [(visible)]="showDialog" [style]="{ width: '720px' }" (onHide)="fechar()">
    <!-- Busca de coordenador (passo alternativo) -->
    @if (passo() === 'buscar-coordenador') {
        <div class="flex flex-col gap-3">
            <div class="flex items-center gap-2">
                <p-button icon="pi pi-arrow-left" severity="secondary" [text]="true" size="small" (onClick)="passo.set('form')" pTooltip="Voltar ao formulário" />
                <span class="font-medium text-sm">Selecionar coordenador</span>
            </div>
            <app-pesquisa-coordenador (selecionado)="onCoordenadorSelecionado($event)" />
        </div>
    }

    <!-- Busca de funcionário (passo alternativo) -->
    @if (passo() === 'buscar-funcionario') {
        <div class="flex flex-col gap-3">
            <div class="flex items-center gap-2">
                <p-button icon="pi pi-arrow-left" severity="secondary" [text]="true" size="small" (onClick)="passo.set('form')" pTooltip="Voltar" />
                <span class="font-medium text-sm">Adicionar funcionário</span>
            </div>
            @if (vinculando()) {
                <div class="flex justify-center py-4">
                    <i class="pi pi-spin pi-spinner text-2xl text-muted-color"></i>
                </div>
            } @else {
                <app-pesquisa-coordenador (selecionado)="onFuncionarioSelecionado($event)" />
            }
        </div>
    }

    <!-- Formulário principal -->
    @if (passo() === 'form' && form) {
        <p-tabs [value]="abaAtiva()" (valueChange)="abaAtiva.set($event)">
            <p-tablist>
                <p-tab value="0"><i class="pi pi-sitemap mr-2"></i>Dados Gerais</p-tab>
                @if (modoEdicao) {
                    <p-tab value="1">
                        <i class="pi pi-users mr-2"></i>
                        Funcionários
                        @if (funcionarios().length > 0) {
                            <span class="ml-2 px-1.5 py-0.5 text-xs font-bold rounded-full bg-primary text-white">
                                {{ funcionarios().length }}
                            </span>
                        }
                    </p-tab>
                }
            </p-tablist>

            <p-tabpanels>
                <!-- ABA: DADOS GERAIS -->
                <p-tabpanel value="0">
                    <form [formGroup]="form" class="flex flex-col gap-4 pt-3">
                        <!-- Descrição + Status -->
                        <div class="grid grid-cols-3 gap-4">
                            <div class="flex flex-col gap-1 col-span-2">
                                <label class="text-sm font-medium">Descrição <span class="text-red-500">*</span></label>
                                <input pInputText formControlName="descricao" placeholder="Nome da estrutura organizacional" class="w-full" />
                                @if (isInvalid('descricao')) {
                                    <small class="text-red-500">Obrigatório (máx. 100 caracteres).</small>
                                }
                            </div>

                            <div class="flex flex-col gap-1">
                                <label class="text-sm font-medium">Status <span class="text-red-500">*</span></label>
                                <p-select [appendTo]="'body'" formControlName="ativo" [options]="opcoesStatus" optionLabel="label" optionValue="value" class="w-full" />
                            </div>
                        </div>

                        <!-- Superior -->
                        <div class="flex flex-col gap-1">
                            <label class="text-sm font-medium">Estrutura superior</label>
                            <p-select [appendTo]="'body'" formControlName="idEoSuperior" [options]="opcoesSuperiores()" optionLabel="label" optionValue="value" placeholder="Selecione (opcional)" [showClear]="true" class="w-full" />
                        </div>

                        <!-- Compartilhar protocolo -->
                        <div class="flex items-center gap-3">
                            <p-checkbox formControlName="inCompartilharProtocolo" [binary]="true" />
                            <label class="text-sm">Compartilhar protocolo entre estruturas</label>
                        </div>

                        <p-divider align="left">
                            <span class="text-sm font-semibold text-muted-color">Coordenador</span>
                        </p-divider>

                        @if (coordenadorSelecionado(); as coord) {
                            <div class="flex items-center justify-between p-3 rounded-xl bg-surface-100 dark:bg-surface-800">
                                <div class="flex items-center gap-3">
                                    <app-pessoa-avatar [foto]="coord.avatar" [iniciais]="iniciaisCoordenador(coord.nome)" [nome]="coord.nome" tamanho="lg" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, coord.nome)" />
                                    <div class="flex flex-col gap-0.5">
                                        <span class="font-semibold text-sm">{{ coord.nome }}</span>
                                        <span class="text-xs text-muted-color">
                                            UF: {{ coord.uf }}
                                            @if (coord.cpf) {
                                                · CPF: {{ coord.cpf }}
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div class="flex gap-2">
                                    <p-button icon="pi pi-pencil" severity="secondary" [text]="true" size="small" pTooltip="Trocar coordenador" (onClick)="abrirBuscaCoordenador()" [appCan]="roleEstruturasEditar" />
                                    <p-button icon="pi pi-times" severity="danger" [text]="true" size="small" pTooltip="Remover coordenador" (onClick)="removerCoordenador()" [appCan]="roleEstruturasEditar" />
                                </div>
                            </div>
                        } @else {
                            <div class="flex items-center justify-between p-3 rounded-xl border-2 border-dashed border-surface-300 dark:border-surface-600">
                                <div class="flex items-center gap-2 text-muted-color">
                                    <i class="pi pi-user-plus"></i>
                                    <span class="text-sm">Nenhum coordenador selecionado</span>
                                </div>
                                <p-button label="Selecionar" icon="pi pi-search" size="small" severity="secondary" (onClick)="abrirBuscaCoordenador()" [appCan]="roleEstruturasEditar" />
                            </div>
                        }
                    </form>
                </p-tabpanel>

                <!-- ABA: FUNCIONÁRIOS -->
                @if (modoEdicao) {
                    <p-tabpanel value="1">
                        <!-- Toolbar: filtro + botão adicionar -->
                        <div class="flex items-center gap-2 pt-2 pb-3">
                            <p-iconfield class="flex-1">
                                <p-inputicon styleClass="pi pi-search" />
                                <input pInputText type="text" class="w-full text-sm" placeholder="Filtrar por nome, CPF ou UF..." [ngModel]="filtroFuncionarios()" (ngModelChange)="filtroFuncionarios.set($event)" />
                            </p-iconfield>
                            <p-button label="Adicionar" icon="pi pi-user-plus" size="small" severity="primary" (onClick)="abrirBuscaFuncionario()" [appCan]="roleEstruturasEditar" />
                        </div>

                        @if (carregandoFuncionarios()) {
                            <div class="flex justify-center py-8">
                                <i class="pi pi-spin pi-spinner text-2xl text-muted-color"></i>
                            </div>
                        } @else {
                            <p-table [value]="funcionariosFiltrados()" styleClass="p-datatable-sm" [rowHover]="true" stripedRows [scrollable]="true" scrollHeight="280px">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 36px"></th>
                                        <th>Nome</th>
                                        <th style="width: 110px">CPF</th>
                                        <th style="width: 46px">UF</th>
                                        <th style="width: 110px">Cargo</th>
                                        <th style="width: 68px" class="text-center">Status</th>
                                        <th style="width: 46px" class="text-center">Ação</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-func>
                                    <tr>
                                        <td>
                                            <app-pessoa-avatar [foto]="func.avatar" [iniciais]="func.nome ? (func.nome[0] | uppercase) : '?'" [nome]="func.nome" tamanho="md" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, func.nome)" />
                                        </td>
                                        <td class="font-medium text-sm">{{ func.nome }}</td>
                                        <td class="font-mono text-xs">{{ func.cpf || '—' }}</td>
                                        <td class="text-xs font-semibold">{{ func.uf }}</td>
                                        <td>
                                            <p-tag [value]="labelTipoFuncionario(func.tipoSolicitante)" severity="secondary" />
                                        </td>
                                        <td class="text-center">
                                            <p-tag value="Ativo" severity="success" styleClass="text-xs" />
                                        </td>
                                        <td class="text-center">
                                            <p-button
                                                icon="pi pi-user-minus"
                                                severity="danger"
                                                [text]="true"
                                                size="small"
                                                pTooltip="Desvincular"
                                                [loading]="removendoId() === func.idSolicitante + '_' + func.uf"
                                                (onClick)="desvincularFuncionario(func)"
                                                [appCan]="roleEstruturasEditar"
                                            />
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7" class="text-center text-muted-color py-8">
                                            <i class="pi pi-users text-3xl block mb-2 opacity-30"></i>
                                            @if (filtroFuncionarios()) {
                                                Nenhum funcionário encontrado para "{{ filtroFuncionarios() }}".
                                            } @else {
                                                Nenhum funcionário vinculado a esta estrutura.
                                            }
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>

                            <!-- Contador de resultados -->
                            @if (funcionarios().length > 0) {
                                <div class="flex justify-between items-center pt-2 text-xs text-muted-color">
                                    <span>
                                        @if (filtroFuncionarios()) {
                                            {{ funcionariosFiltrados().length }} de {{ funcionarios().length }} funcionários
                                        } @else {
                                            {{ funcionarios().length }} funcionário{{ funcionarios().length !== 1 ? 's' : '' }} vinculado{{ funcionarios().length !== 1 ? 's' : '' }}
                                        }
                                    </span>
                                    @if (filtroFuncionarios()) {
                                        <p-button label="Limpar filtro" icon="pi pi-times" [text]="true" size="small" severity="secondary" (onClick)="filtroFuncionarios.set('')" />
                                    }
                                </div>
                            }
                        }
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    }

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancelar" severity="secondary" [text]="true" (onClick)="fechar()" />
            @if (passo() === 'form') {
                <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (onClick)="salvar()" [appCan]="modoEdicao ? roleEstruturasEditar : roleEstruturasCriar" />
            }
        </div>
    </ng-template>
</p-dialog>

<app-pessoa-foto-dialog [(foto)]="fotoAmpliada" [nome]="nomeFotoAmpliada()" />
